import Flickity from 'flickity';
import {players} from '../plugins/plyr';

class carouselOverlay {
	constructor(element) {
		this.DOM = {element};
		this.DOM.carousel = this.DOM.element.querySelector('.carousel--overlay');
		this.DOM.ctrls = {
			close: this.DOM.element.querySelector('.pane__carousel-close'),
		};

		this.flkty = Flickity.data(this.DOM.carousel);

		this.initEvents();
	}
	initEvents() {
        // Zet autoplay uit
		this.flkty.on('select', (index) => this.pauzeVideo(index));
		this.DOM.ctrls.close.addEventListener('click', () => this.stopVideo());
		document.addEventListener('keyup', (event) => this.closeOverlay(event));
	}
	playVideo(index) {
		const selectedSlide = this.flkty.cells[index].element;
		const playerContainer = selectedSlide.querySelector('.carousel__slide-inner');
		const player = players.find((player) => player.id === playerContainer.id);

		players.forEach((player) => {
			if (player.id !== playerContainer.id) player.plyr.stop();
		});

		if (player) player.plyr.play();
	}
	stopVideo() {
		players.forEach((player) => player.plyr.stop());
	}
    pauzeVideo() {
        players.forEach((player) => player.plyr.pause());
    }
	closeOverlay(event) {
		if (event.which === 27) {
			this.stopVideo();
			this.DOM.element.classList.remove('is-open');
		}
	}
}

const carouselOverlayNodes = document.querySelectorAll('.carousel-overlay');
[...carouselOverlayNodes].forEach((node) => new carouselOverlay(node));
